export type PauseableTimeout = {
  pause: () => void;
  resume: () => void;
  clear: () => void;
};

enum TimeoutState {
  PAUSED,
  RUNNING,
  CLEARED,
}

export const createTimeout = (
  callback: () => void,
  delay: number,
): PauseableTimeout => {
  let timeoutId: ReturnType<typeof setTimeout>;
  let state = TimeoutState.PAUSED;
  let timeElapsed = 0;
  let timeStart: number;

  const handleTimeout = () => {
    state = TimeoutState.CLEARED;
    callback();
  };

  const pause = () => {
    if (state !== TimeoutState.RUNNING) {
      return;
    }

    state = TimeoutState.PAUSED;
    timeElapsed += Date.now() - timeStart;
    clearTimeout(timeoutId);
  };

  const resume = () => {
    if (state !== TimeoutState.PAUSED) {
      return;
    }

    state = TimeoutState.RUNNING;
    timeStart = Date.now();
    timeoutId = setTimeout(handleTimeout, delay - timeElapsed);
  };

  const clear = () => {
    if (state === TimeoutState.CLEARED) {
      return;
    }

    state = TimeoutState.CLEARED;
    clearTimeout(timeoutId);
  };

  return { pause, resume, clear };
};
